import { createFileRoute } from "@tanstack/react-router";
import { m } from "#/paraglide/messages";
import { PcrInputQueueView } from "#/components/pages/pcr-input/pcr-input-queue-view";

export const Route = createFileRoute("/$tenantCode/$market/pcr-input-all")({
  beforeLoad: () => ({ getTitle: () => m["resources.pcrInput.name"]() }),
  component: PcrInputAllRoute,
});

function PcrInputAllRoute() {
  return <PcrInputQueueView pcrUploadId={undefined} />;
}
